<div class="results-panel panel right">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <span matBadge="{{resultItems.length}}" matBadgeOverlap="false">Results</span>
      <span class="toolbar-spacer"></span>
      <button mat-icon-button class="btn">
        <mat-icon class="toolbar-icon" aria-hidden="false" aria-label="Close" (click)="closeResultsPanel()">close
        </mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="panel-content">
    <mat-accordion>
      @for (resultItem of resultItems; track resultItem; let i = $index) {
        <mat-expansion-panel (afterExpand)="resultItem.populate()">
          @if (i < loadLimit) {
            <mat-expansion-panel-header class="seperate">
              <h3 class="expansion-header-name">{{resultItem.sourceName}}</h3>
              <div class="icon-source">
                <div class="source">{{resultItem.summaryObject?.type?.name}}</div>
                <div class="map-marker-icon" [innerHTML]="resultItem.iconHtml"></div>
              </div>
            </mat-expansion-panel-header>
          }
          @if (!resultItem.isReady && i < loadLimit) {
            <app-ev-loading></app-ev-loading>
          }
          @if (resultItem.isReady && i < loadLimit) {
            <div>
              @switch (resultItem.type) {
                @case (RESULT_TYPE_ENUM.VOLCANO) {
                  <div>
                    <mat-card class="item-card">
                      <mat-card-header>
                        <div mat-card-avatar class="example-header-image"
                        [ngStyle]="{'background-image': 'url(' + resultItem.imageUrl + ')'}"></div>
                        <mat-card-title>{{resultItem.name}}</mat-card-title>
                        <mat-card-subtitle>Volcano type: {{resultItem.subTitle}}</mat-card-subtitle>
                      </mat-card-header>
                      <img mat-card-image [src]="resultItem.imageUrl" alt="Image">
                      <mat-card-content>
                        <p>
                          {{resultItem.summary}}
                        </p>
                        @if (resultItem.volcanoLink != null) {
                          <div class="link-evc">
                  <a [href]="'https://volcanoes.eurovolc.eu/?volcano=' + resultItem.volcanoLink" target="_blank">
                    <button type="button" mat-stroked-button color="primary">View in European Catalogue of
                      Volcanoes</button>
                  </a>
                </div>
}
              </mat-card-content>
            </mat-card>
          </div>
}

          @case (RESULT_TYPE_ENUM.SEARCH) {
<div class="observation-styling">

            <h3>Observation summary</h3>
            <div class="list-item-space">
              <div><span>ID: </span><span class="resultItemContent">{{resultItem.summaryObject.id}}</span></div>
              <div><span>Type: </span><span class="resultItemContent">{{resultItem.summaryObject.type?.name}}</span>
              </div>
              <div><span>Country: </span><span class="resultItemContent">{{resultItem.summaryObject.country?.name ||
                  'None'}}</span></div>
                  <div><span>Source: </span><span class="resultItemContent">{{resultItem.summaryObject.source?.name}}</span>
                </div>
                <div><span>Description: </span><span
              class="resultItemContent">{{resultItem.summaryObject.description}}</span></div>
              <div><span>Date: </span><span class="resultItemContent">{{resultItem.summaryObject.dateObserved |
            date:'full'}}</span></div>
            <div><span>Coordinates: </span>
            <div>
              <div class="coordinates">
                <div>lat: {{resultItem.summaryObject.locationPoint?.lat | number}}</div>
                <div>long: {{resultItem.summaryObject.locationPoint?.lon | number}}</div>
              </div>
            </div>
          </div>
        </div>
        @if (resultItem.obsDetails.images.length > 0) {
          <div>
            <h3>Images</h3>
            <div class="container-row">
              @for (image of resultItem.obsDetails.images; track image) {
                <div class="column">
                  <a [href]="image.url" target="_blank">
                    <img [src]="image.thumbnail ? image.thumbnail : image.url" [alt]="image.file">
                  </a>
                </div>
              }
            </div>
          </div>
        }
        @if (resultItem.detailObject.properties.length > 0) {
          <h3>Properties</h3>
        }
        @if (resultItem.detailObject.properties.length > 0) {
          <div class="max-width">
            <table class="mat-table mat-elevation-z2 margin-bottom" mat-table
              [dataSource]="resultItem.detailObject.properties">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Property Name </th>
                <td mat-cell *matCellDef="let PropertyObject"> {{PropertyObject.property.name}} </td>
              </ng-container>
              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef class="resultItemContent"> Value </th>
                <td mat-cell *matCellDef="let PropertyObject" class="resultItemContent"> {{PropertyObject.value}}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        }
        @if (resultItem.detailObject.keywords.length > 0) {
          <h3>Keywords</h3>
        }
        <div>
          @if (resultItem.detailObject.keywords.length > 0) {
            <mat-chip-listbox aria-label="Keywords">
              @for (dictItem of resultItem.detailObject.keywords; track dictItem) {
                <mat-chip color="primary" selected>
                  {{dictItem.name}}
                </mat-chip>
              }
            </mat-chip-listbox>
          }
        </div>
        <h3>Actions</h3>
        <div class="button-row-actions obsActions">
          @if (resultItem.summaryObject.locationPoint) {
            <button mat-stroked-button color="primary"
              (click)="goToLocation(resultItem.summaryObject.locationPoint)">Zoom
            to location</button>
          }
        </div>
      </div>
    }
  }
</div>
}
</mat-expansion-panel>
}

</mat-accordion>
@if (loadLimit < resultItems.length) {
  <button class="more-button" type="button" mat-stroked-button color="primary"
    (click)="loadMore()">
    Load More
  </button>
}
</div>
</div>